module.exports = __webpack_public_path__ + "img/shoe4.061ccfe5.png";